module.exports = __webpack_public_path__ + "static/media/3-5.dbacd8e8.jpg";